<template>
  <div>
    <put-modal
      v-if="order.client.id == 10001"
      :order="order"
      @put-away-order="putAway"></put-modal>
    <receive-modal :order="order" @receive-order="receive"></receive-modal>
    <div class="btn-group m-0 ml-2" v-if="!updating">

      <button class="btn btn-sm btn-outline-dark" @click="approve" v-if="order.status.id == 2">
        <i class="fa fa-check"></i> Approve this order
      </button>

      <button
        class="btn btn-sm btn-outline-dark" @click="accept" v-if="order.status.id == 4">
        <i class="fa fa-truck-loading"></i> This order has arrived
      </button>

      <button class="btn btn-sm btn-outline-dark" @click="showReceiveModal" v-if="order.status.id == 12">
        <i class="fa fa-clipboard-list"></i> Recieve this order
      </button>
      
      <button 
        class="btn btn-sm btn-outline-dark"
        @click="showPutModal"
        v-if="order.status.id == 14 && order.client.id == 10001">
        <i class="fa fa-truck-loading"></i> Put this order away
      </button>
      <router-link v-else-if="order.status.id == 14"
        :to="`/inbound/${order.id}/put-away`"
        class="btn btn-sm btn-outline-dark"
      >
        <i class="fa fa-truck-loading"></i> Put Away
      </router-link>

      <print-dropdown :order="order"></print-dropdown>
    </div>
    <div v-else>
      <i class="fa fa-spinner fa-spin"></i> Updating
    </div>
  </div>
</template>

<script>

import n from '@/libs/notifications'
import store from '@/stores/inbound'
import inboundOrder from '@/libs/inbound-order'

import ReceiveModal from '@/components/inbound/ReceiveModal'
import PutModal from '@/components/inbound/PutAwayCartonsModal'
import PrintDropdown from '@/components/inbound/PrintDropdown'

import $ from 'jquery'

export default {
  name: 'action-buttons',

  components: {
    ReceiveModal,
    PrintDropdown,
    PutModal
  },

  data() {
    return {
      updating: false,
      putModalVisable: false,
    }
  },

  props: {
    order: Object,
  },

  methods: {
    navigateToStatus() {
      const status = this.$route.params.status
      this.$router.push({ name: 'inbound', params: { status }})
    },

    approve() {
      this.updating = true
      inboundOrder.approve(this.order).then(res => {
        store.updateOrder(res.data.order)
        this.navigateToStatus()
        n.success("Order is now approved.")
      }).catch(err => {
        n.error(err)
      }).finally(() => this.updating = false)
    },

    accept() {
      this.updating = true
      inboundOrder.accept(this.order).then(res => {
        store.updateOrder(res.data.order)
        this.navigateToStatus()
        n.success("Order has been accepted.")
      }).catch(err => {
        n.error(err)
      }).finally(() => this.updating = false)
    },

    showReceiveModal() { $('#receiveModal').modal('show') },
    hideReceiveModal() { $('#receiveModal').modal('hide') },

    showPutModal() { 
      this.putModalVisable = true;
      setTimeout(() => {
        $('#putAwayModal').modal('show') 
      }, 500)
    },

    hidePutModal() { 
      $('#putAwayModal').modal('hide') 
      this.putModalVisable = false;
      // setTimeout(() => {
        
      // }, 1000)
    },

    receive() {
      this.updating = true
      inboundOrder.receive(this.order).then(res => {
        store.updateOrder(res.data.order)
        this.navigateToStatus()
        this.hideReceiveModal()
        n.success("Order has been received.")
      }).catch(err => {
        n.error(err)
      }).finally(() => this.updating = false)
    },

    putAway() {
      this.updating = true
      inboundOrder.putAway(this.order, true).then(res => {
        store.updateOrder(res.data.order)
        this.navigateToStatus()
        this.hidePutModal()
        n.success("Order has been put away.")
      }).catch(err => {
        n.error(err)
      }).finally(() => this.updating = false)
    }
  }
}
</script>
